import { injectable } from 'inversify';
import base from '@/Framework/url/baseUrl';
import Tracker from '../../Tracker';
import TrackRequest from '../../TrackRequest';

@injectable()
export class BeaconSender implements Tracker {
  async track({ eventName, payload }) {
    const request = new TrackRequest(eventName, payload);
    navigator.sendBeacon(base.getRpcUrl(), JSON.stringify(request));
    return Promise.resolve();
  }
}

export default BeaconSender;
